import type { CSSObject } from '@emotion/react'
import { Color, FocusIndicator, Size, Theme, Typeface } from '@opallabs/gem'

type StyleProps = { theme: Theme }

export const link = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme]['Text/Links'],
  // Provides a nice effect when focused.
  borderRadius: Size.Rounding,
  fontFamily: Typeface.Default,

  '&:focus': {
    ...FocusIndicator[theme],
  },
})
